import { emptyAsNull } from "@common/lib/zod"
import { z } from "zod"

export const partRefSchema = z.union([
  z.object({ id: z.string(), number: z.string() }),
  z.object({
    number: z.string().min(1),
    description: emptyAsNull(z.string().trim()),
  }),
])

export type ExistingPartValue = { id: string; number: string }

export type PartRefValue =
  | ExistingPartValue
  | { number: string; description: string | null }

export function isExistingPart(
  value: PartRefValue,
): value is Extract<PartRefValue, { id: string }> {
  return "id" in value
}

export function partLabel(value: PartRefValue): string {
  return value.number
}
